(function () {
  "use strict";

  /* Fires ONE event per click on the custom elements added to this PDP.
     Purely observational: no preventDefault, no stopPropagation, and the
     whole handler is wrapped so a tracking error can never break a click.

     Where it sends:
       1. window.dataLayer  (Elevar / GTM is already on this store)
       2. window.gtag       (only if dataLayer is absent, so GA4 cannot double count)
       3. window.klaviyo    (separate system, no double-count risk)

     ADJUST HERE: the event name GTM will listen for. */
  var EVENT = "vs_click";
  var KLAVIYO_METRIC = "PDP Element Click";

  /* The theme's own #btnCTA handler calls stopImmediatePropagation() in the
     CAPTURE phase, so NO click listener on this page ever sees the main Add To
     Cart. Listening on MOUSEDOWN instead sidesteps that entirely: it is a
     different event type, it fires first, and nothing suppresses it. The
     handler is left alone on purpose - unblocking it would let other bound
     click listeners run and risk a double add. */
  var ATC_SEL = '#btnCTA, .vs-cta-btn, button[name="add"], [data-slidecart-atc]';
  var ATC_DEDUPE_MS = 800;
  var lastAtc = 0;

  /* Order matters: the first match wins, so a click is counted once. */
  var TARGETS = [
    { sel: "[data-vs-size]", element: "size_guide_add_to_cart" },
    { sel: ".vs-sg__quiz", element: "size_guide_fit_quiz_link" },
    { sel: ".vs-fit__cta", element: "fit_modal_cta" },
    { sel: "[data-vs-buy]", element: "story_modal_cta" },
    { sel: "[data-vs-sglink]", element: "size_guide_link" },
    { sel: "[data-vs-fitlink]", element: "fit_link" },
    { sel: "[data-vs-story]", element: "story_link" },
    { sel: "[data-vs-cta]", element: "mid_page_cta" }
  ];

  var DEBUG = false;
  try {
    DEBUG = window.location.search.indexOf("vsdebug=1") > -1;
  } catch (e) {}

  function txt(el) {
    return (el.textContent || "").replace(/\s+/g, " ").trim().slice(0, 80);
  }

  function detail(el, element) {
    if (element === "size_guide_add_to_cart") return el.getAttribute("data-vs-size") || "";
    if (element === "mid_page_cta") return el.getAttribute("data-vs-cta") || "";
    if (element === "story_link") return el.getAttribute("data-vs-story") || "";
    return "";
  }

  function fold(el) {
    try {
      var top = el.getBoundingClientRect().top + (window.pageYOffset || 0);
      var vh = window.innerHeight || 0;
      return vh && top < vh ? "above_fold" : "below_fold";
    } catch (e) {
      return "unknown";
    }
  }

  function send(payload) {
    var sent = [];

    try {
      if (window.dataLayer && typeof window.dataLayer.push === "function") {
        window.dataLayer.push(payload);
        sent.push("dataLayer");
      } else if (typeof window.gtag === "function") {
        window.gtag("event", EVENT, {
          vs_element: payload.vs_element,
          vs_label: payload.vs_label,
          vs_detail: payload.vs_detail,
          vs_position: payload.vs_position
        });
        sent.push("gtag");
      }
    } catch (e) {}

    try {
      if (window.klaviyo && typeof window.klaviyo.push === "function") {
        window.klaviyo.push([
          "track",
          KLAVIYO_METRIC,
          {
            Element: payload.vs_element,
            Label: payload.vs_label,
            Detail: payload.vs_detail,
            Position: payload.vs_position,
            Page: payload.vs_page
          }
        ]);
        sent.push("klaviyo");
      }
    } catch (e) {}

    if (DEBUG && window.console && console.log) {
      console.log("[vs-track]", payload.vs_element, payload, "sent to:", sent.join(", ") || "nothing");
    }
  }

  function trackAtc(ev) {
    try {
      var t = ev.target;
      if (!t || !t.closest) return;
      var hit = t.closest(ATC_SEL);
      if (!hit) return;

      var now = Date.now();
      if (now - lastAtc < ATC_DEDUPE_MS) return;
      lastAtc = now;

      send({
        event: EVENT,
        vs_element: "main_add_to_cart",
        vs_label: txt(hit),
        vs_detail: hit.id || "",
        vs_position: fold(hit),
        vs_page: (location.pathname || "").slice(0, 120)
      });
    } catch (e) {}
  }

  document.addEventListener("mousedown", trackAtc, true);
  document.addEventListener("touchstart", trackAtc, true);

  document.addEventListener(
    "click",
    function (ev) {
      try {
        var t = ev.target;
        if (!t || !t.closest) return;

        for (var i = 0; i < TARGETS.length; i++) {
          var hit = t.closest(TARGETS[i].sel);
          if (!hit) continue;

          send({
            event: EVENT,
            vs_element: TARGETS[i].element,
            vs_label: txt(hit),
            vs_detail: detail(hit, TARGETS[i].element),
            vs_position: fold(hit),
            vs_page: (location.pathname || "").slice(0, 120)
          });
          return;
        }
      } catch (e) {}
    },
    true
  );

  if (DEBUG && window.console && console.log) {
    console.log("[vs-track] active. Event name:", EVENT);
  }
})();
